import React from "react"
import { useTaskReportExportContext } from "contexts/TaskReportExportContext"
import { Checkbox } from "shared/checkboxes"
import MassSelection from "shared/MassSelection"

const NewTaskReportExportSubmittableFormFilter = () => {
  const {
    excludeAllForms,
    includeAllForms,
    includedFormSlugs,
    noSubmittableFormIncluded,
    submittableForms,
    toggleIncludedFormSlug,
  } = useTaskReportExportContext()

  return (
    <>
      <MassSelection className="mb-5" deselectAll={excludeAllForms} selectAll={includeAllForms} />
      <div className="space-y-2">
        {
          submittableForms.map(({ slug, title }) => {
            const optionIdentifier = `task-report-export-submittable-form-${slug}`

            return (
              <div className="flex items-center" key={slug}>
                <Checkbox
                  className="mr-4"
                  onChange={() => toggleIncludedFormSlug(slug)}
                  uuid={optionIdentifier}
                  value={includedFormSlugs.includes(slug)}
                />
                <label className="cursor-pointer" htmlFor={optionIdentifier}>
                  {title}
                </label>
              </div>
            )
          })
        }
      </div>
      {
        noSubmittableFormIncluded && (
          <p className="text-xs text-error mt-2">
            At least one form must be selected.
          </p>
        )
      }
    </>
  )
}

export default NewTaskReportExportSubmittableFormFilter
